import { render, staticRenderFns } from "./NotificationSnackBar.vue?vue&type=template&id=43ab2f15&scoped=true&"
import script from "./NotificationSnackBar.vue?vue&type=script&lang=js&"
export * from "./NotificationSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab2f15",
  null
  
)

export default component.exports